<template>
  <div id="app">
    <!-- Modal -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <!-- Video -->
        <video
          class="modal-video"
          src="/assets/images/81949-toggle-dark-mode-light-mode-themes.mp4"
          autoplay
          :muted="true"
          loop
          playsinline
          webkit-playsinline
          ref="modalVideo"
        ></video>

        <!-- Teks dan tombol -->
        <p>
          Untuk mendapatkan tampilan terbaik <strong>nonaktifkan dark mode / mode gelap</strong>
          dan gunakan <strong>Chrome</strong> atau <strong>Safari</strong>
        </p>
        <button @click="closeModal" class="btn-mengerti">Saya Mengerti</button>
      </div>
    </div>

    <!-- Konten utama -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      showModal: true,
    };
  },
  watch: {
    '$route.name'(newName) {
      if (newName === 'NotFoundPage') {
        this.showModal = false;
      }
    }
  },
  mounted() {
    if (this.$route.name === 'NotFoundPage') {
      this.showModal = false;
    }
    
    // Force autoplay on iOS - try playing video programmatically
    this.$nextTick(() => {
      setTimeout(() => {
        const video = this.$refs.modalVideo;
        if (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {
              // Autoplay was prevented, show video controls as fallback
              // but keep it muted so next user interaction can trigger it
              document.addEventListener('touchstart', () => {
                video.play();
              }, { once: true });
            });
          }
        }
      }, 100);
    });
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px);
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.modal-video {
  width: 100%;
  border-radius: 6px;
  margin-bottom: 1rem;
  max-height: 200px;
}

.modal-content p {
  margin-bottom: 1.5rem;
  font-size: 1rem;
  color: #333;
}

.btn-mengerti {
  background-color: #000;
  color: #fff;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.btn-mengerti:hover {
  background-color: #333;
}

@media (max-width: 600px) {
  .modal-content {
    margin: 0 1rem;
    width: 100%;
    max-width: none;
    padding: 1.5rem;
  }

  .modal-content p {
    font-size: 0.95rem;
  }

  .btn-mengerti {
    width: 100%;
  }
}
</style>
